import React from "react";
import { Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { connect } from "react-redux";

import InternalLayout from "../layouts/Internal";

import Login from "../pages/Auth/Login";
import Register from "../pages/Auth/Register";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import Dashboard from "../pages/Dashboard";

import Loading from "../components/Loading";

interface Props {
	loggedIn: any;
}

const RoutingSystem: React.FC<Props> = ({ loggedIn }) => {
	return (
		<IonReactRouter>
			<Loading />
			{/* <NotificationPopOver /> */}
			<IonRouterOutlet id="main-content">
				<Route path="/" exact>
					{!loggedIn && <Login />}
					{loggedIn && (
						<InternalLayout>
							<Dashboard />
						</InternalLayout>
					)}
				</Route>
				<Route path="/login" component={Login} exact />
				<Route path="/register" component={Register} exact />
				<Route path="/forgotpassword" component={ForgotPassword} exact />
				{/* <Route path="/admin" component={AdminLayout} /> */}
				<InternalLayout />
				{/* <Route path={"/admin/output"} component={OutputScreen} exact /> */}
			</IonRouterOutlet>
		</IonReactRouter>
	);
};

const mapStateToProps = (state: any) => ({
	loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {})(RoutingSystem);
